'use strict';

var moduleConfig = require('../utils/module-config');

module.exports = function (arg) {
  var send = moduleConfig(arg);
  return {
    get: require('./get')(send),
    set: require('./set')(send),
    replace: require('./replace')(send)
  };
};